import type { ReactNode } from 'react';

export interface TabDef {
  id: string;
  label: string;
  count?: number;
}

interface Props {
  tabs: TabDef[];
  value: string;
  onChange: (id: string) => void;
  right?: ReactNode;
}

export function Tabs({ tabs, value, onChange, right }: Props) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        borderBottom: '1px solid var(--line)',
        marginBottom: 16,
      }}
    >
      <div style={{ display: 'flex', gap: 4, flex: 1, overflowX: 'auto' }}>
        {tabs.map((t) => {
          const active = t.id === value;
          return (
            <button
              key={t.id}
              onClick={() => onChange(t.id)}
              style={{
                position: 'relative',
                padding: '10px 14px 12px',
                fontSize: 13,
                fontWeight: active ? 600 : 500,
                color: active ? 'var(--ink)' : 'var(--ink-3)',
                borderBottom: active ? '2px solid var(--brand)' : '2px solid transparent',
                marginBottom: -1,
                whiteSpace: 'nowrap',
                transition: 'color 0.15s ease',
              }}
            >
              {t.label}
              {t.count != null && (
                <span
                  style={{
                    marginLeft: 8,
                    fontSize: 11,
                    fontFamily: 'var(--font-mono)',
                    background: active ? 'var(--brand-soft)' : 'var(--bg-sunken)',
                    color: active ? 'var(--brand-ink)' : 'var(--ink-3)',
                    padding: '1px 6px',
                    borderRadius: 'var(--r-pill)',
                  }}
                >
                  {t.count}
                </span>
              )}
            </button>
          );
        })}
      </div>
      {right && <div style={{ paddingBottom: 6 }}>{right}</div>}
    </div>
  );
}
